import axios from "../util/axios";
import AuthHeader from "./authHeader";

const getProjects = (userId) => {
  return axios.get("/project/?user_id=" + userId, { headers: AuthHeader() });
}; //  **********************

const getProjectsDashboard = (userId) => {
  return axios.get("/project/dashboard/?user_id=" + userId, {
    headers: AuthHeader(),
  });
};

const convertProjectIntoTasks = (data) => {
  return axios.post("/convert", data, { headers: AuthHeader() });
};

const getProjectTasks = (projectId) => {
  return axios.get(`/tasks/?project_id=${projectId}`, {
    headers: AuthHeader(),
  });
};

const addTasksSubtasks = (task, subtask) => {
  return axios.post(
    `/subtask/multiple-create/`,
    { task, subtask },
    { headers: AuthHeader() }
  );
};
const getUsersTasks = (userId) => {
  return axios.get(`/tasks/?user_id=${userId}`, { headers: AuthHeader() });
};

const getUserTeam = (userId) => {
  return axios.get(`/teams/?user_id=${userId}`, { headers: AuthHeader() });
};

const updateTaskStatus = (data, id) => {
  return axios.patch(`/tasks/${id}/`, data, { headers: AuthHeader() });
};

const generateSubTasks = (data) => {
  return axios.post("/subtaskgenerator", data, { headers: AuthHeader() });
};

const getSubTasks = (taskid) => {
  return axios.get(`/subtask/?task_id=${taskid}`, { headers: AuthHeader() });
};

const updateProjectStatus = (data, id) => {
  return axios.patch(`/project/${id}/`, data, { headers: AuthHeader() });
};

const getProjectsCount = (id) => {
  return axios.get(`/project/count/?user_id=${id}`, { headers: AuthHeader() });
};

const getProjectsByDivision = (userId, division) => {
  return axios.get(`/project/?division=${division}&user_id=${userId}`, {
    headers: AuthHeader(),
  });
};

const getProjectsByTheme = (userId, theme) => {
  const encodedTheme = encodeURIComponent(theme);
  return axios.get(
    `/project/?strategicTheme=${encodedTheme}&user_id=${userId}`,
    { headers: AuthHeader() }
  );
};

const getPriorityProjectsByTheme = (userId) => {
  return axios.get(`/project/byStrategicTheme/?user_id=${userId}`, {
    headers: AuthHeader(),
  });
};

const getProjectDetails = (id) => {
  return axios.get(`/project/${id}/`, { headers: AuthHeader() });
};

const getMilestones = (id) => {
  return axios.get(`/milestone/?project_id=${id}`, { headers: AuthHeader() });
};

const addNewTask = (data) => {
  return axios.post(`/tasks/`, data, { headers: AuthHeader() });
};

const updateSubTaskStatus = (data, id) => {
  return axios.patch(`/subtask/${id}/`, data, { headers: AuthHeader() });
};

const toggleVote = (userid, projectId) => {
  return axios.post(
    `/project/${projectId}/vote/`,
    { user_id: userid },
    { headers: AuthHeader() }
  );
};

const hasVoted = (projectId, userId) => {
  return axios.get(`/project/${projectId}/check-vote/?user_id=${userId}`, {
    headers: AuthHeader(),
  });
};

const addComment = (data) => {
  return axios.post(`/comment/`, data, { headers: AuthHeader() });
};

const getProjectComments = (projectId) => {
  return axios.get(`/comment/?project_id=${projectId}`, {
    headers: AuthHeader(),
  });
};

const getDepartments = () => {
  return axios.get(`/departments/`);
};

const getDivisions = () => {
  return axios.get(`/divisions/`);
};

const getUserDepartments = () => {
  return axios.get(`/departments/`, { headers: AuthHeader() });
};

const getUserDivisions = () => {
  return axios.get(`/divisions/`, { headers: AuthHeader() });
};
const getUserTeams = () => {
  return axios.get(`/teams/`, { headers: AuthHeader() });
};

const getStrategicThemes = () => {
  return axios.get(`/strategic-themes/`, { headers: AuthHeader() });
};

const getStrategicThemesClearPlan = () => {
  return axios.get(`/strategic-themes/clear-plan-strategic-themes/`, {
    headers: AuthHeader(),
  });
};

const createNotification = (data) => {
  return axios.post(`/notification/`, data, { headers: AuthHeader() });
};

const getUsersNotification = (userId) => {
  return axios.get(`/notification/?user_id=${userId}`, {
    headers: AuthHeader(),
  });
};

const updateNotification = (data, id) => {
  return axios.patch(`/notification/${id}/`, data, { headers: AuthHeader() });
};

const readAllNotification = (data) => {
  return axios.post(`/notification/mark-all-read/`, data, {
    headers: AuthHeader(),
  });
};

const deleteAllNotification = (data) => {
  return axios.post(`/notification/delete-unread/`, data, {
    headers: AuthHeader(),
  });
};

const getAdminAnalytics = () => {
  return axios.get(`/details/`, { headers: AuthHeader() });
};

const createMilestone = (data) => {
  return axios.post(`/milestone/`, data, { headers: AuthHeader() });
};

const deleteMilestone = (id) => {
  return axios.delete(`/milestone/${id}/`, { headers: AuthHeader() });
};

const addNote = (data) => {
  return axios.post(`/note/`, data, { headers: AuthHeader() });
};

const deleteNote = (id) => {
  return axios.delete(`/note/${id}/`, { headers: AuthHeader() });
};

const updateNote = (data, id) => {
  return axios.patch(`/note/${id}/`, data, { headers: AuthHeader() });
};

const getProjectNotes = (id, userId) => {
  return axios.get(`/note/?project_id=${id}&?user_id=${userId}`, {
    headers: AuthHeader(),
  });
};

const updateMilestone = (data, id) => {
  return axios.patch(`/milestone/${id}/`, data, { headers: AuthHeader() });
};

const getMilestoneTasks = (milestoneId) => {
  return axios.get(`/tasks/?milestone_id=${milestoneId}`, {
    headers: AuthHeader(),
  });
};

const addEscalation = (data) => {
  return axios.post(`/escalation/`, data, { headers: AuthHeader() });
};

const getProjectEscalations = (id) => {
  return axios.get(`/escalation/?project_id=${id}`, { headers: AuthHeader() });
};

const updateEscalation = (id, data) => {
  return axios.patch(`/escalation/${id}/`, data, { headers: AuthHeader() });
};

const getEscalationComment = (id) => {
  return axios.get(`/comment/?escalation_id=${id}`, { headers: AuthHeader() });
};

const deleteEscalation = (id) => {
  return axios.delete(`/escalation/${id}/`, { headers: AuthHeader() });
};

const searchUser = (email) => {
  return axios.get(`/users/?search=${email}`, { headers: AuthHeader() });
};

const createTeam = (data) => {
  return axios.post(`/teams/`, data, { headers: AuthHeader() });
};

const updateTeam = (id, data) => {
  return axios.patch(`/teams/${id}/`, data, { headers: AuthHeader() });
};

const deleteTeam = (id) => {
  return axios.delete(`/teams/${id}/`, { headers: AuthHeader() });
};

const addTemplate = (data) => {
  return axios.post(`/whiteboard/`, data, { headers: AuthHeader() });
};

const getTemplates = () => {
  return axios.get(`/whiteboard/?is_template=true`, { headers: AuthHeader() });
};

const getTemplateById = (id) => {
  return axios.get(`/whiteboard/${id}/`, { headers: AuthHeader() });
};

const getUserDrawings = (id) => {
  return axios.get(`/whiteboard/?is_template=false&user_id=` + id, {
    headers: AuthHeader(),
  });
};

const deleteNotification = (id) => {
  return axios.delete(`/notification/${id}/`, { headers: AuthHeader() });
};

const getProjectDrawings = (id) => {
  return axios.get(`/whiteboard/?is_template=false&project_id=` + id, {
    headers: AuthHeader(),
  });
};

const delegateToSeniors = (data, id) => {
  return axios.post(`/project/${id}/delegate/`, data, {
    headers: AuthHeader(),
  });
};

const getAllProjects = (userId) => {
  // return axios.get(`/project/`,{headers:AuthHeader()});
  return axios.get(`/project/?user_id=${userId}`, { headers: AuthHeader() });
};

const getApprovalProjects = (userId) => {
  return axios.get(`/approval/?user_id=${userId}`, { headers: AuthHeader() });
};

const updateProfile = (data, userId) => {
  return axios.patch(`/users/${userId}/`, data, { headers: AuthHeader() });
};

const createChatRequest = (userId) => {
  return axios.post(
    `/chat-requests/`,
    { to_user_id: userId },
    { headers: AuthHeader() }
  );
};

const getConversations = () => {
  return axios.get(`/my-rooms/`, { headers: AuthHeader() });
};

const getCurrentMessages = (roomId) => {
  return axios.get(`/messages/?room_id=${roomId}`, { headers: AuthHeader() });
};

const updateChatRequest = (id, data) => {
  return axios.patch(`/chat-requests/${id}/`, data, { headers: AuthHeader() });
};

const deleteDrawing = (id) => {
  return axios.delete(`/whiteboard/${id}/`, { headers: AuthHeader() });
};

const getAllUsers = () => {
  return axios.get(`/users/admin/`, { headers: AuthHeader() });
};

const updateUser = (data, id) => {
  return axios.patch(`/users/${id}/update-details/`, data, {
    headers: AuthHeader(),
  });
};

const deleteUser = (id) => {
  return axios.delete(`/users/${id}/`, { headers: AuthHeader() });
};

const createAutoEscalation = (id, data) => {
  return axios.post(`/escalation/${id}/escalate/`, data, {
    headers: AuthHeader(),
  });
};

const drawWithAI = (data) => {
  return axios.post(`/fishbone/`, data, { headers: AuthHeader() });
};

const createSuperTask = (data) => {
  return axios.post(`/tasks/create-super-task/`, data, {
    headers: AuthHeader(),
  });
};

const getUsersEscalations = (userId) => {
  return axios.get(`/escalation/escalated-to-user/?user_id=${userId}`, {
    headers: AuthHeader(),
  });
};

const getTeamsPerformance = () => {
  return axios.get("/teams/performance/", { headers: AuthHeader() });
};

const getUserReports = () => {
  return axios.get(`/user-reports`, { headers: AuthHeader() });
};

const updateFormData = (id, data) => {
  return axios.patch(`/session/${id}/`, data, { headers: AuthHeader() });
};

const deleteReport = (id) => {
  return axios.delete(`/session/${id}/`, { headers: AuthHeader() });
};

const addTheme = (data) => {
  return axios.post("/strategic-themes/", data, {
    headers: AuthHeader(),
  });
};

// Edit report showing logic
const editReportTemplateVisiblity = (id, data) => {
  return axios.get(`/session/${id}/feedback/ `, data, {
    headers: AuthHeader(),
  });
};

// Get all themes
const getThemes = () => {
  return axios.get("/strategic-themes/", { headers: AuthHeader() });
};

// Update an existing theme
const updateTheme = (id, data) => {
  return axios.patch(`/strategic-themes/${id}/`, data, {
    headers: AuthHeader(),
  });
};

// Delete a theme
const deleteTheme = (id) => {
  return axios.delete(`/strategic-themes/${id}/`, {
    headers: AuthHeader(),
  });
};

const getMetricCategories = () =>
  axios.get("/metric-categories/", { headers: AuthHeader() });
const addMetricCategory = (data) =>
  axios.post("/metric-categories/", data, { headers: AuthHeader() });
const updateMetricCategory = (id, data) =>
  axios.put(`/metric-categories/${id}/`, data, { headers: AuthHeader() });
const deleteMetricCategory = (id) =>
  axios.delete(`/metric-categories/${id}/`, { headers: AuthHeader() });

const getMetrics = () => {
  return axios.get("/metric-names/", { headers: AuthHeader() });
};

const addMetric = (metricData) => {
  return axios.post("/metric-names/", metricData, { headers: AuthHeader() });
};

const updateMetric = (id, metricData) => {
  return axios.put(`/metric-names/${id}/`, metricData, {
    headers: AuthHeader(),
  });
};

const deleteMetric = (id) => {
  return axios.delete(`/metric-names/${id}/`, { headers: AuthHeader() });
};

const getCostBenefitCategories = () => {
  return axios.get("/costbenefit-categories/", { headers: AuthHeader() });
};

const deleteCostBenefitCategories = (categoryId) => {
  return axios.delete(`/costbenefit-categories/${categoryId}`, {
    headers: AuthHeader(),
  });
};

const deleteCostBenefitSubcategory = (subCategoryId) => {
  return axios.delete(`/costbenefit-subcategories/${subCategoryId}/`, {
    headers: AuthHeader(),
  });
};

const updateCostBenefitCategory = (id, values) => {
  return axios.put(`/costbenefit-categories/${id}/`, values, {
    headers: AuthHeader(),
  });
};

const createCostBenefitCategory = (values) => {
  return axios.post("/costbenefit-categories/", values, {
    headers: AuthHeader(),
  });
};

const updateCostBenefitSubcategory = (id, values) => {
  return axios.put(`/costbenefit-subcategories/${id}/`, values, {
    headers: AuthHeader(),
  });
};

const createCostBenefitSubcategory = (values) => {
  return axios.post("/costbenefit-subcategories/", values, {
    headers: AuthHeader(),
  });
};

const uploadCsvForAdmin = (formData) => {
  return axios.post("/users/admincsv/", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      ...AuthHeader(),
    },
  });
};

const createDivision = (data) => {
  return axios.post("/divisions/", data, { headers: AuthHeader() });
};

const deleteDivision = (id) => {
  return axios.delete(`/divisions/${id}/`, { headers: AuthHeader() });
};

const updateDivision = (id, data) => {
  return axios.put(`/divisions/${id}/`, data, { headers: AuthHeader() });
};

const createDepartment = (data) => {
  return axios.post("/departments/", data, { headers: AuthHeader() });
};

const deleteDepartment = (id) => {
  return axios.delete(`/departments/${id}/`, { headers: AuthHeader() });
};

const updateDepartment = (id, data) => {
  return axios.put(`/departments/${id}/`, data, { headers: AuthHeader() });
};

const getProjectBenefits = (projectId) => {
  return axios.get(`/costbenefits/?project_id=${projectId}`, {
    headers: AuthHeader(),
  });
};

const getProjectMetrics = (projectId) => {
  return axios.get(`/metrics/?project_id=${projectId}`, {
    headers: AuthHeader(),
  });
}; // **************************

const addProjectMetric = (data) => {
  return axios.post(`/metrics/`, data, { headers: AuthHeader() });
};

const deleteProjectMetric = (id) => {
  return axios.delete(`/metrics/${id}/`, { headers: AuthHeader() });
};

const addDataPoint = (data) => {
  return axios.post(`/metric-datapoints/`, data, { headers: AuthHeader() });
}; // ********************

const updateProjectMetric = (metricId, metricData) => {
  return axios.put(`/metrics/${metricId}/`, metricData, {
    headers: AuthHeader(),
  });
};

const createConsultationForm = async (data) => {
  return axios.post("/consultation-form/", data);
};

const createContactForm = async (data) => {
  return axios.post("/contact-us/", data);
};

const createEarlyAccess = async (data) => {
  return axios.post("/early-access/", data);
};

const getConsultationData = () => {
  return axios.get("/consultation-form/", { headers: AuthHeader() });
};

const getContactData = () => {
  return axios.get("/contact-us/", { headers: AuthHeader() });
};

const getEarlyAccessData = () => {
  return axios.get("/early-access/", { headers: AuthHeader() });
};

const getProjectStaffAnalytics = (month) => {
  return axios.get(`/analytics/project-staff-patient/?month=${month}`, {
    headers: AuthHeader(),
  });
};

const getEscalationStats = (month) => {
  return axios.get(`/analytics/escalation-dashboard/?month=${month}`, {
    headers: AuthHeader(),
  });
};

const getEscalationStatusDistribution = (month) => {
  return axios.get(
    `/analytics/escalation-status-distribution/?month=${month}`,
    { headers: AuthHeader() }
  );
};

const getEscalationStatusMonthWise = (month) => {
  return axios.get(`/analytics/escalation-created-mitigated/?month=${month}`, {
    headers: AuthHeader(),
  });
};

const getEscalationEconomicImpact = (month) => {
  return axios.get(`/analytics/escalation-economic-impact/?month=${month}`, {
    headers: AuthHeader(),
  });
};

const getQuarterlyCostBenefit = (month) => {
  return axios.get(
    `/analytics/projects-quarterly-cost-benefit/?month=${month}`,
    { headers: AuthHeader() }
  );
};

const getProjectCardAnalytics = (month) => {
  return axios.get(`/analytics/project-card-analytics/?month=${month}`, {
    headers: AuthHeader(),
  });
};

const getRevenueBreakdown = (month) => {
  return axios.get(`/analytics/projects-benefit-monthly/?month=${month}`, {
    headers: AuthHeader(),
  });
};

const getAllOrganisations = () => {
  return axios.get(`/organisations/`, { headers: AuthHeader() });
};

const getOrganisationById = (id) => {
  return axios.get(`/organisations/${id}/`, { headers: AuthHeader() });
};

const createOrganisation = (organisationData) => {
  return axios.post(`/organisations/`, organisationData);
};

const updateOrganisation = (id, organisationData) => {
  return axios.put(`/organisations/${id}/`, organisationData, {
    headers: AuthHeader(),
  });
};

const deleteOrganisation = (id) => {
  return axios.delete(`/organisations/${id}/`, { headers: AuthHeader() });
};

const getProjectCompletion = (month) => {
  return axios.get(`/analytics/projects-completion-count/?month=${month}`, {
    headers: AuthHeader(),
  });
};

const getCostBenefitByCategoriesData = (month) => {
  return axios.get(`/analytics/cost-benefit-donut/?month=${month}`, {
    headers: AuthHeader(),
  });
};

const getProjectBreakdown = (month) => {
  return axios.get(
    `/analytics/project-type-breakdown-dashboard/?month=${month}`,
    { headers: AuthHeader() }
  );
};

const getProjectRadarData = (month) => {
  return axios.get(`/analytics/project-escalation-radar/?month=${month}`, {
    headers: AuthHeader(),
  });
};

const getSentimentAnalysis = (month) => {
  return axios.get(`/analytics/sentiment-analysis/?month=${month}`, {
    headers: AuthHeader(),
  });
};

const getSentimentWordCloud = (month) => {
  return axios.get(`/analytics/sentiment-analysis-word-cloud/?month=${month}`, {
    headers: AuthHeader(),
  });
};

const getOrganisationLeaderboard = (month) => {
  return axios.get(`/analytics/leaderboard/?type=organisation&month=${month}`, {
    headers: AuthHeader(),
  });
};

const getDivisionLeaderboard = (month) => {
  return axios.get(`/analytics/leaderboard/?type=division&month=${month}`, {
    headers: AuthHeader(),
  });
};

const getTeamLeaderboard = (month) => {
  return axios.get(`/analytics/leaderboard/?type=team&month=${month}`, {
    headers: AuthHeader(),
  });
};

const getIndividualLeaderboard = (month) => {
  return axios.get(`/analytics/leaderboard/?month=${month}`, {
    headers: AuthHeader(),
  });
};

const getProjectMonthlyBreakdown = (month) => {
  return axios.get(`/analytics/project-monthly-breakdown/?month=${month}`, {
    headers: AuthHeader(),
  });
};

const getProjectFunnel = (month) => {
  return axios.get(`/analytics/project-funnel/?month=${month}`, {
    headers: AuthHeader(),
  });
};

const getEscalationSeverityType = (month) => {
  return axios.get(`/analytics/escalations-severity-type/?month=${month}`, {
    headers: AuthHeader(),
  });
};

const getEscalationHeatmap = (month) => {
  return axios.get(`/analytics/escalations-heatmap/?month=${month}`, {
    headers: AuthHeader(),
  });
};

const getPotentialProjectAnalytics = (month) => {
  return axios.get(`/analytics/parked-project-analytics/?month=${month}`, {
    headers: AuthHeader(),
  });
};

const getMilestonesByStages = (id) => {
  return axios.get(`/milestone/?project_id=${id}&isStage=true`, {
    headers: AuthHeader(),
  });
};

const getDefaultTemplateData = (id) => {
  return axios.get(`/template-data/`);
};

// List all features
const getAllFeatures = () => {
  return axios.get("/features/", { headers: AuthHeader() });
};

// Create a new feature request
const createFeatureRequest = (featureData) => {
  return axios.post("/features/", featureData, { headers: AuthHeader() });
};

// Upvote a feature
const upvoteFeature = (featureId) => {
  return axios.post(
    "/feature-vote/",
    { feature: featureId, vote_type: "up" },
    { headers: AuthHeader() }
  );
};

// Downvote a feature (or change the vote to downvote)
const downvoteFeature = (featureId) => {
  return axios.post(
    "/feature-vote/",
    { feature: featureId, vote_type: "down" },
    { headers: AuthHeader() }
  );
};

const createIdeaComment = (data) => {
  return axios.post("/feature-comments/", data, { headers: AuthHeader() });
};

const getSentimentSPCAnalytics = () => {
  return axios.get("/analytics/sentiment-spc/", { headers: AuthHeader() });
};

const getPotentialProjects = () => {
  return axios.get(`/analytics/parked-project-analytics/`, {
    headers: AuthHeader(),
  });
};

const getRaciData = (id) => {
  return axios.get(`/analytics/raci-matrix/?project_id=${id}`, {
    headers: AuthHeader(),
  });
};

const getWorkloadData = (id) => {
  return axios.get(`/analytics/workload/?project_id=${id}`, {
    headers: AuthHeader(),
  });
};

const getMetricData = (id) => {
  return axios.get(`/metrics/?project_id=${id}`, { headers: AuthHeader() });
};

const getMetricById = (id) => {
  return axios.get(`/metrics/${id}/`, { headers: AuthHeader() });
};

const createCompleteProfile = (id, data) => {
  return axios.post(`/complete-profile/?user_id=${id}`, data);
};

const deleteSubTask = (id) => {
  return axios.delete(`/subtask/${id}/`, { headers: AuthHeader() });
};

const sendInvite = (data) => {
  return axios.post("/send-invite/", data, { headers: AuthHeader() });
};

const uploadProjectFile = (data, id) => {
  return axios.post(`/project/${id}/upload-file/`, data, {
    headers: AuthHeader(),
  });
};

const getOrganisationLimit = () => {
  return axios.get(`/organisation-usage/`, { headers: AuthHeader() });
};

const userCheckoutSession = (data) => {
  return axios.post(`/checkout-session/`, data, { headers: AuthHeader() });
};

const getIndivialProjectWorkload = (id) => {
  return axios.get(`/project/${id}/workload/`, { headers: AuthHeader() });
};

// /tasks/paginated-tasks/?user_id=10&page=1
const getAllTasksByPagination = (id, page) => {
  return axios.get(`/tasks/paginated-tasks/?user_id=${id}&page=${page}`, {
    headers: AuthHeader(),
  });
};

const getAllCompletedTasksByPagination = (id, page) => {
  return axios.get(
    `/tasks/paginated-completed-tasks/?user_id=${id}&page=${page}`,
    {
      headers: AuthHeader(),
    }
  );
};

const getAllTodaysTasksByPagination = (id, page) => {
  return axios.get(`/tasks/paginated-today-tasks/?user_id=${id}&page=${page}`, {
    headers: AuthHeader(),
  });
};

const getPaginatedTasksForCalender = (id, date) => {
  return axios.get(
    `/tasks/paginated-month-tasks/?user_id=${id}&month=${date}`,
    {
      headers: AuthHeader(),
    }
  );
};

const getPaginatedTodoTask = (id, page) => {
  return axios.get(`/tasks/paginated-to-do-tasks/?user_id=${id}&page=${page}`, {
    headers: AuthHeader(),
  });
};

const getPaginatedInProgressTask = (id, page) => {
  return axios.get(
    `/tasks/paginated-in-progress-tasks/?user_id=${id}&page=${page}`,
    {
      headers: AuthHeader(),
    }
  );
};

// PROJECT PAGE ROUTES

const getPaginatedInReviewProject = (id, page) => {
  return axios.get(
    `/project/paginated-review-projects/?user_id=${id}&page=${page}`,
    {
      headers: AuthHeader(),
    }
  );
};

const getPaginatedPlannedProject = (id, page) => {
  return axios.get(
    `/project/paginated-planned-projects/?user_id=${id}&page=${page}`,
    {
      headers: AuthHeader(),
    }
  );
};

const getPaginatedInProgressProject = (id, page) => {
  return axios.get(
    `/project/paginated-inprogress-projects/?user_id=${id}&page=${page}`,
    {
      headers: AuthHeader(),
    }
  );
};

const getPaginatedCompletedProject = (id, page) => {
  return axios.get(
    `/project/paginated-completed-projects/?user_id=${id}&page=${page}`,
    {
      headers: AuthHeader(),
    }
  );
};

const getPaginatedArchivedProject = (id, page) => {
  return axios.get(
    `/project/paginated-archived-projects/?user_id=${id}&page=${page}`,
    {
      headers: AuthHeader(),
    }
  );
};

const getPaginatedParkedProject = (id, page) => {
  return axios.get(
    `/project/paginated-parked-projects/?user_id=${id}&page=${page}`,
    {
      headers: AuthHeader(),
    }
  );
};

const ProjectServices = {
  editReportTemplateVisiblity,
  getAllTasksByPagination,
  getAllCompletedTasksByPagination,
  getAllTodaysTasksByPagination,
  getPaginatedTodoTask,
  getPaginatedInProgressTask,
  getPaginatedTasksForCalender,

  // project Pagination
  getPaginatedInReviewProject,
  getPaginatedPlannedProject,
  getPaginatedInProgressProject,
  getPaginatedCompletedProject,
  getPaginatedArchivedProject,
  getPaginatedParkedProject,

  getOrganisationLimit,
  getAllFeatures,
  uploadProjectFile,
  getUserDepartments,
  getUserDivisions,
  getUserTeams,
  sendInvite,
  createCompleteProfile,
  getDefaultTemplateData,
  getMetricData,
  getMetricById,
  deleteSubTask,
  getWorkloadData,
  getRaciData,
  getPotentialProjects,
  createIdeaComment,
  createFeatureRequest,
  upvoteFeature,
  downvoteFeature,
  getSentimentSPCAnalytics,
  getSentimentAnalysis,
  getMilestonesByStages,
  getSentimentWordCloud,
  getOrganisationLeaderboard,
  getDivisionLeaderboard,
  getTeamLeaderboard,
  getIndividualLeaderboard,
  getProjectMonthlyBreakdown,
  getProjectFunnel,
  getPotentialProjectAnalytics,
  getProjectMetrics,
  getProjectBenefits,
  getProjectRadarData,
  getProjectBreakdown,
  getProjectCompletion,
  getQuarterlyCostBenefit,
  getCostBenefitByCategoriesData,
  getAllOrganisations,
  getOrganisationById,
  createOrganisation,
  updateOrganisation,
  deleteOrganisation,
  getRevenueBreakdown,
  createEarlyAccess,
  getProjectCardAnalytics,
  getEscalationEconomicImpact,
  getEscalationStatusMonthWise,
  getEscalationStatusDistribution,
  getEscalationHeatmap,
  getEscalationSeverityType,
  getProjectStaffAnalytics,
  getConsultationData,
  getEarlyAccessData,
  getContactData,
  createContactForm,
  createConsultationForm,
  addDataPoint,
  deleteProjectMetric,
  updateProjectMetric,
  addTheme,
  getThemes,
  updateTheme,
  deleteTheme,
  getMetrics,
  addProjectMetric,
  addMetric,
  createDivision,
  deleteDivision,
  updateDivision,
  createDepartment,
  deleteDepartment,
  updateDepartment,
  uploadCsvForAdmin,
  updateMetric,
  deleteMetric,
  getCostBenefitCategories,
  deleteCostBenefitCategories,
  updateCostBenefitSubcategory,
  createCostBenefitSubcategory,
  createCostBenefitCategory,
  updateCostBenefitCategory,
  deleteCostBenefitSubcategory,
  getMetricCategories,
  addMetricCategory,
  updateMetricCategory,
  deleteMetricCategory,
  addTemplate,
  updateFormData,
  deleteReport,
  getUserReports,
  getTeamsPerformance,
  createSuperTask,
  drawWithAI,
  getUsersEscalations,
  getEscalationComment,
  getAdminAnalytics,
  createAutoEscalation,
  updateUser,
  deleteUser,
  getAllUsers,
  getStrategicThemes,
  getStrategicThemesClearPlan,
  getDepartments,
  getDivisions,
  getConversations,
  deleteDrawing,
  getProjects,
  getProjectsDashboard,
  convertProjectIntoTasks,
  updateChatRequest,
  getProjectTasks,
  getUsersTasks,
  updateTaskStatus,
  getProjectsCount,
  addNewTask,
  updateProjectStatus,
  getProjectDetails,
  generateSubTasks,
  getSubTasks,
  updateSubTaskStatus,
  toggleVote,
  hasVoted,
  addComment,
  getProjectComments,
  createNotification,
  getUsersNotification,
  updateNotification,
  readAllNotification,
  deleteAllNotification,
  getMilestones,
  createMilestone,
  getPriorityProjectsByTheme,
  deleteMilestone,
  addNote,
  deleteNote,
  updateNote,
  getProjectNotes,
  updateMilestone,
  getMilestoneTasks,
  addEscalation,
  getProjectEscalations,
  updateEscalation,
  deleteEscalation,
  searchUser,
  createTeam,
  updateTeam,
  deleteTeam,
  getUserTeam,
  getTemplates,
  getTemplateById,
  getUserDrawings,
  deleteNotification,
  getProjectDrawings,
  getProjectsByDivision,
  getProjectsByTheme,
  delegateToSeniors,
  getAllProjects,
  getApprovalProjects,
  updateProfile,
  createChatRequest,
  getCurrentMessages,
  getEscalationStats,
  userCheckoutSession,
  addTasksSubtasks,
  getIndivialProjectWorkload,
};

export default ProjectServices;
